export enum LogoColor {
    Default = 'dark',
    Light = 'light',
    Dark = 'dark'
}

export enum LogoType {
    Default = 'with_text',
    NoText = 'no_text',
    WithText = 'with_text'
}